<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { GLOGAU_SCALE_OPTIONS } from '../types/glogau-scale'

    export let data: Record<string, any>
</script>

<div class="glogau-scale">
    {#each GLOGAU_SCALE_OPTIONS as option (option.key)}
        <div class="glogau-row" class:selected={option.key === 'II'}>
            <span class="glogau-type">
                {option.label}
                <span class="glogau-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <span class="glogau-age">{option.ageRange}</span>
            <span class="glogau-desc">{option.description}</span>
        </div>
    {/each}
</div>

<style>
    .glogau-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .glogau-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .glogau-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .glogau-type {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .glogau-row.selected .glogau-type {
        color: #1f2937;
    }
    .glogau-age {
        flex: 1;
        min-width: 0;
        text-align: center;
        font-size: 0.85rem;
        color: #495057;
    }
    .glogau-desc {
        flex: 1;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .glogau-row.selected .glogau-age,
    .glogau-row.selected .glogau-desc {
        color: #1f2937;
    }
    .glogau-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .glogau-row.selected .glogau-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
